import { render, staticRenderFns } from "./OfferPremiumInfo.vue?vue&type=template&id=ab5dd948"
import script from "./OfferPremiumInfo.vue?vue&type=script&lang=js"
export * from "./OfferPremiumInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports